import { getToken } from 'firebase/messaging';

const getFCMToken = async (messaging) => {
  try {
    if (!messaging) {
      throw new Error('Messaging instance is undefined or null.');
    }

    // Check if VAPID key is defined
    const vapidKey = 'BIXL6rRvz3HRjfLykJVBLz4LSXbRRZF917sxcG29JayIcCu1JHCPnP3ExR5CO9PFOVPJDf4PbE4wVpianLjaqpo';
    if (!vapidKey) {
      throw new Error('VAPID key is not defined.');
    }

    // Use getToken method to obtain the FCM token
    const currentToken = await getToken(messaging, { vapidKey });

    if (currentToken) {
      // Log the FCM token if available
      console.log('Client Token:', currentToken);
      return currentToken;
    } else {
      // Log an error message if the token generation failed
      console.log('Failed to generate the registration token.');
      return null;
    }
  } catch (err) {
    // Log an error if an exception occurs during the token request
    console.error('Error:', err);
    return null;
  }
};

export default getFCMToken;
